export default __webpack_public_path__ + "static/media/12.90e4f61b.png";